import { render, staticRenderFns } from "./instructionCategoryForm.vue?vue&type=template&id=0717e897"
import script from "./instructionCategoryForm.vue?vue&type=script&lang=js"
export * from "./instructionCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports